import { usePublic } from "helpers/utlities";
import { get } from "./AXIOS"
import {
  ALL_PUBLIC_SYSTEMS, ALL_SYSTEMS,
  LABEL_SPECIFIC_COUNTRIES,
  LIST_COUNTRIES,
  LIST_LABELS_FOR_BENCHMARKING,
  LIST_LANDSCAPING_FOCAL_AREAS,
  LIST_PUBLIC_COUNTRIES,
  LIST_STAGES, LIST_PUBLIC_STAGES, BENCHMARKING_SYSTEMS
} from "./CONSTANTS"

// list Countries
export const listCountries = () => {
  return get(usePublic() ? LIST_PUBLIC_COUNTRIES : LIST_COUNTRIES)
}

// list Stages
export const listStages = () => get(usePublic() ? LIST_PUBLIC_STAGES : LIST_STAGES)

// list systems
export const listAllSystems = () => get(usePublic() ? ALL_PUBLIC_SYSTEMS : ALL_SYSTEMS)
// list systems for benchmarking
export const benchmarkingMilestoneSystems = () => get(BENCHMARKING_SYSTEMS)
//list systems for benchmarking form creation

export const listSystems = () => get(LIST_LABELS_FOR_BENCHMARKING)

//list countries to which the user selected system is mapped to

export const listSystemSpecificCountries = id =>
  get(`${LABEL_SPECIFIC_COUNTRIES}/${id}`)

export const landscapingFocalAreas = (landscapingCategory) => get(LIST_LANDSCAPING_FOCAL_AREAS(landscapingCategory));

export const listPolicyTypes = () => get()
